import App from './app';
import dayjs from 'dayjs';
import {createRoot} from "react-dom/client";
dayjs.locale('de')

createRoot(document.getElementById('root') as HTMLElement).render(<App/>);